import { render, staticRenderFns } from "./AsignacionItems.vue?vue&type=template&id=64a96a88&scoped=true&"
import script from "./AsignacionItems.vue?vue&type=script&lang=js&"
export * from "./AsignacionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a96a88",
  null
  
)

export default component.exports